import { Grid, TextField } from "@mui/material";
import React from "react";
import Dragger from "antd/lib/upload/Dragger";
import { InboxOutlined } from "@ant-design/icons";

const AddEditDocumentsForm = ({
  documentDetails,
  setDocumentDetails,
  errors,
}) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setDocumentDetails((prevUser) => ({
      ...prevUser,
      [name]: value,
    }));
  };

  const handleBeforeUpload = (file) => {
    setDocumentDetails((prevUser) => ({
      ...prevUser,
      file: file,
      fileName: file.name,
      fileType: file.type,
    }));
    return false;
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid xs={12} item>
          <TextField
            required
            fullWidth
            value={documentDetails?.title}
            name="title"
            label="Ttile"
            variant="outlined"
            error={errors?.title}
            helperText={errors?.title}
            onChange={handleChange}
          />
        </Grid>
        <Grid xs={12} item>
          <TextField
            fullWidth
            value={documentDetails?.description}
            multiline
            rows={2}
            name="description"
            label="Description"
            variant="outlined"
            onChange={handleChange}
            sx={{ height: "auto", "& .MuiInputBase-root": { height: "auto" } }}
          />
        </Grid>

        <Grid xs={12} item>
          <Dragger
            beforeUpload={handleBeforeUpload}
            multiple={false}
            showUploadList={documentDetails?.file ? true : false}
            accept=".pdf,.doc,.docx,.xls,.xlsx"
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined style={{ color: "var(--main-theme-color)" }} />
            </p>
            <p className="ant-upload-text">
              Click or drag file to this area to upload
            </p>
            <p className="ant-upload-hint">
              Supports PDF, Word, Excel documents
            </p>

            {documentDetails?.fileName && (
              <div style={{ margin: "16px 0" }}>
                <strong>Selected:</strong> {documentDetails?.fileName}
              </div>
            )}
            {errors?.fileName && (
              <div style={{ margin: "16px 0", color: "#d32f2f" }}>
                <strong>{errors?.fileName}</strong>
              </div>
            )}
          </Dragger>
        </Grid>
      </Grid>
    </>
  );
};

export default AddEditDocumentsForm;
